import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BehaviorSubject } from 'rxjs';

import { BarActionButton } from '../../../../bar-action-button/bar-action-button';
import { BarActionButtonOptions } from '../../../../bar-action-button/bar-action-button-options.model';
import { BarActionButtonType } from '../../../../bar-action-button/bar-action-button-type.enum';
import { BarLayoutService } from '../../bar-layout.service';

@Component({
    selector: 'bar-layout-menu-striking-actions',
    templateUrl: './bar-layout-menu-striking-actions.component.html',
    host: { class: 'bar-layout-menu-striking-actions' },
    imports: [BarActionButton, AsyncPipe]
})
export class BarLayoutMenuStrikingActionsComponent implements OnInit {
    readonly #layout = inject(BarLayoutService);
    readonly #destroyRef = inject(DestroyRef);

    strikingActions$: BehaviorSubject<BarActionButtonOptions[]> = new BehaviorSubject([]);

    ngOnInit() {
        this.#layout.strikingActions$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((actions: BarActionButtonOptions[]) => {
            const transformActions = (actions) => {
                return actions.map((a) => {
                    a.type = BarActionButtonType.Stroked;
                    return a;
                });
            };
            if (actions) this.strikingActions$.next(transformActions(actions));
            else this.strikingActions$.next(actions);
        });
    }
}
